import { render } from "./MenuBtn.vue?vue&type=template&id=7ae8712a&scoped=true&ts=true"
import script from "./MenuBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuBtn.vue?vue&type=script&setup=true&lang=ts"

import "./MenuBtn.vue?vue&type=style&index=0&id=7ae8712a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae8712a"],['__file',"src/components/header/MenuBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ae8712a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ae8712a', __exports__)) {
    api.reload('7ae8712a', __exports__)
  }
  
  module.hot.accept("./MenuBtn.vue?vue&type=template&id=7ae8712a&scoped=true&ts=true", () => {
    api.rerender('7ae8712a', render)
  })

}


export default __exports__